import { PageOpenPoseView } from './PageOpenPoseView';

export function PageOpenPose() {
  return <PageOpenPoseView />;
}
